import { render, staticRenderFns } from "./AppSelectList.vue?vue&type=template&id=33ee050a&scoped=true"
import script from "./AppSelectList.vue?vue&type=script&lang=ts"
export * from "./AppSelectList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ee050a",
  null
  
)

export default component.exports